import { React, Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import {
  CrossIcon,
  ExclamationIcon,
  InfoCheckIcon,
} from './icons/IconProvider';
const ConfirmationPop = ({
  isPop,
  setPop,
  functionCall,
  secondButton,
  FirstButton,
  secondText,
  FirstText,
  slug,
}) => {
  const cancelButtonRef = useRef(null);
  return (
    <>
      <Transition.Root show={isPop} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={() => {} /* Prevent closing when clicking outside */}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-5 pb-10 pt-5 relative">
                    <button
                      onClick={() => setPop(false)}
                      className="w-10 h-10 flex items-center justify-center border border-gray-100 text-gray-600 rounded-full p-0 absolute top-3 right-3 hover:bg-gray-100"
                    >
                      <CrossIcon />
                    </button>
                    <div className="text-center sm:text-left">
                      <div className="mt-4 text-center">
                        <div className="w-full text-center">
                          {slug === 'publish' && <InfoCheckIcon />}

                          {(slug === 'unpublish' ||
                            slug === 'transferFreeze' ||
                            slug === 'deploy' ||
                            slug === 'redirect') && <ExclamationIcon />}
                        </div>

                        <h4 className="mb-2 font-semibold">
                          {FirstText || 'NA'}
                        </h4>
                        <p className=" text-lg mb-6">{secondText || 'NA'}</p>

                        {/* <p className="text-gray-700">Do doing this can avoid the future conflict.</p> */}
                      </div>
                    </div>
                    <div className="w-full mt-5 text-center">
                      {FirstButton !== null && (
                        <button
                          onClick={() => setPop(false)}
                          className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-white border border-gray-300 mr-3"
                        >
                          {FirstButton || 'NA'}
                        </button>
                      )}

                      <button
                        onClick={() => functionCall(slug)}
                        className="px-4 py-2.5 rounded-md font-medium text-base text-brandBlue bg-GreenColor"
                      >
                        {secondButton || 'NA'}
                      </button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};
export default ConfirmationPop;
